export const products = [
  {
    id: "PWGCDBJJ02C",
    slug: "rush-ls",
    shopUrl: "https://shop.powerhousegym.jp/collections/phg-cdbjj/products/carpe-diem-bjj-long-sleeve-rash-guard",
    name: "PHG x CDBJJ RASH.G L/S",
    category: "RASH GUARD L/S",
    price: 9800,
    material: "ポリエステル100%",
    tagline: "鍛える現実から目を逸らさない。",
    description:
      "Live the Discipline Active Collection。高負荷セッションのすべてに付き合う長袖ラッシュガード。ポリエステル100%が汗を素早く処理し、インターバルを跨いでもドライなコンディションを維持する。スキンタイトな着用感が筋肉のブレをほどよく抑え、テクニックとパワーへの集中を保つ。デッドリフトのシンスクレイプ、ケーブルとの摩擦──あらゆる実戦的負荷から腕を保護する。\n\n筋肉を整えることは、自分を整えることだ。",
    features: ["吸汗速乾", "スキンタイトフィット", "腕部保護", "筋肉ブレ抑制"],
    colors: [
      {
        label: "BLACK",
        image: "/images/3.jpg",
      },
      {
        label: "GRAY",
        image: "/images/8.jpg",
      },
    ],
    image: "/images/3.jpg",
    sizeHeaders: ["サイズ", "着丈 (cm)", "身幅 (cm)", "袖丈 (cm)", "体重目安 (kg)"],
    sizeRows: [
      ["S", "63", "40", "67", "50〜60"],
      ["M", "66", "42", "69", "60〜70"],
      ["L", "69", "44", "72", "70〜80"],
      ["XL", "71", "45", "74", "80〜90"],
      ["XXL", "73", "47", "78", "90〜100"],
    ],
    sizeNote: "体重目安は標準体型を基準。筋量多め・肩幅広めの方は1サイズアップを推奨。",
  },
  {
    id: "PWGCDBJJ03C",
    slug: "rush-ss",
    shopUrl: "https://shop.powerhousegym.jp/collections/phg-cdbjj/products/carpe-diem-bjj-half-sleeve-rash-guard",
    name: "PHG x CDBJJ RASH.G H/S",
    category: "RASH GUARD H/S",
    price: 8800,
    material: "ポリエステル100%",
    tagline: "筋肉を鍛えることは、自分を整えること。",
    description:
      "Live the Discipline Active Collection。ショルダープレス、ラットプルダウン、チンニング──肩関節の可動域を最大限に要求するすべての種目で、袖口が動作の邪魔をしない。ポリエステル100%が高強度インターバル中もドライ感を持続し、鏡でのフォーム確認時に筋肉の動きが明確に見える。パフォーマンスと見た目を、どちらも妥協しない。\n\n鍛える現実に正面から向き合う。それがこのウェアの理由だ。",
    features: ["肩関節フリー設計", "吸汗速乾", "ドライ持続", "コンプレッションフィット"],
    colors: [
      {
        label: "BLACK",
        image: "/images/A1_5399.jpg",
      },
      {
        label: "GRAY",
        image: "/images/A1_5580.jpg",
      },
    ],
    image: "/images/A1_5399.jpg",
    sizeHeaders: ["サイズ", "着丈 (cm)", "身幅 (cm)", "アームホール (cm)", "体重目安 (kg)"],
    sizeRows: [
      ["S", "63", "40", "46", "50〜60"],
      ["M", "66", "42", "48", "60〜70"],
      ["L", "69", "44", "50", "70〜80"],
      ["XL", "71", "45", "52", "80〜90"],
      ["XXL", "73", "47", "54", "90〜100"],
    ],
    sizeNote: "体重目安は標準体型を基準。筋量多め・肩幅広めの方は1サイズアップを推奨。",
  },
  {
    id: "PWGCDBJJ04C",
    slug: "fight-shorts",
    shopUrl: "https://shop.powerhousegym.jp/collections/phg-cdbjj/products/carpe-diem-bjj-grappling-shorts",
    name: "PHG x CDBJJ FIGHT SHORTS",
    category: "FIGHT SHORTS",
    price: 9800,
    material: "ポリエステル95% / スパンデックス5%",
    tagline: "鍛え抜いた下半身の力を、逃がさない。",
    description:
      "Live the Discipline Active Collection。レッグプレス、ブルガリアンスプリットスクワット、ルーマニアンデッドリフト──深い股関節の可動域を要求するすべての種目を妥協なくこなすためのショーツ。スパンデックス5%配合の4ウェイストレッチが「突っ張り」を消し、ウェスト約15cmのアジャスト幅が増量期・減量期の体型変化を一枚でカバーする。裾スリットがステップアップ、ハイキックの動作制限を排除する。\n\n筋肉を整えることは、自分を整えること。そのための一着だ。",
    features: ["4ウェイストレッチ", "ウェストアジャスト±15cm", "裾スリット設計", "増量・減量対応"],
    colors: [
      {
        label: "BLACK",
        image: "/images/5.jpg",
      },
      {
        label: "GRAY",
        image: "/images/10.png",
      },
    ],
    image: "/images/5.jpg",
    sizeHeaders: ["サイズ", "ウェスト調整範囲 (cm)", "着丈 (cm)", "股下 (cm)", "体重目安 (kg)"],
    sizeRows: [
      ["S", "67〜82", "40.5", "14.5", "50〜60"],
      ["M", "72〜87", "41.5", "15", "60〜70"],
      ["L", "77〜92", "43", "16", "70〜80"],
      ["XL", "82〜97", "45", "16.5", "80〜90"],
      ["XXL", "87〜102", "46.5", "17", "90〜100"],
    ],
    sizeNote: "ウェスト数値はドローコードによるアジャスト対応範囲。体重目安は標準体型を基準としています。",
  },
  {
    id: "PWGCDBJJ01C",
    slug: "tee",
    shopUrl: "https://shop.powerhousegym.jp/collections/phg-cdbjj/products/carpe-diem-bjj-print-tee",
    name: "PHG x CDBJJ WIDE TEE",
    category: "T-SHIRT",
    price: 6000,
    material: "綿100% / 5.6oz / セミコーマ糸",
    tagline: "Train to Live. — 生きるために、鍛える。",
    description:
      "Power House Gym × Carpe Diem BJJ Live the Discipline Active Collectionの限定コラボレーションコットンTシャツ。フロント左胸にCarpe Diem BJJのサークルロゴ、右胸にPower House Gymのダイヤモンドロゴ。バックにはPOWER HOUSE GYMのアーチ文字を冠に、ダンベルカールをする鍛え抜かれた男の上半身をハイコントラストで刻む。輪郭を際立たせたグラフィックは、積み重ねた鍛錬が身体に彫り込んだ証を視覚化する。\n\nビッグシルエット設計で、鍛え抜いた肩や胸でも窮屈さなく着こなせる。5.6ozセミコーマ糸のコットンが落ち感と肌なじみを両立し、スパーリング後の道場でもトレーニング後のジム帰りでも、そのまま街に出られる質感を持つ。\n\n静かに燃える──GYMでも道場でも、闘うように生きる人のための特別な装い。",
    features: ["ビッグシルエット", "コラボグラフィック", "5.6ozセミコーマ糸", "コットン100%"],
    colors: null,
    image: "/images/A1_5576.jpg",
    sizeNote: "サイズ感に不安がある場合はお問い合わせください。",
    sizeHeaders: ["サイズ", "着丈 (cm)", "身幅 (cm)", "肩幅 (cm)", "袖丈 (cm)"],
    sizeRows: [
      ["S", "66", "55", "52", "21"],
      ["M", "70", "58", "55", "23"],
      ["L", "74", "61", "58", "25"],
      ["XL", "78", "64", "61", "27"],
    ],
  },
];

// 着用写真（セパレーター・Hero・ギャラリー用）
export const actionPhotos = [
  // [0] TEE 5人集合
  "/images/A1_5320.jpg",
  // [1] 全員
  "/images/A1_5314.jpg",
  // [2] BW_5
  "/images/BW_5.jpg",
  // [3] _A1_5517
  "/images/A1_5517.jpg",
  // [4] _A1_5493
  "/images/A1_5493.jpg",
  // [5] _A1_5561
  "/images/A1_5561.jpg",
  // [6] _A1_5580
  "/images/A1_5580.jpg",
  // [7] _A1_5485
  "/images/A1_5485.jpg",
  // [8] _A1_5613
  "/images/A1_5613.jpg",
  // [9] _A1_5559
  "/images/A1_5559.jpg",
  // [10] _A1_5592
  "/images/A1_5592.jpg",
  // [11] _A1_5500
  "/images/A1_5500.jpg",
  // [12] 高級ライティング_3 — L/S BLACK物撮り（白背景）
  "/images/3.jpg",
  // [13] _A1_5357 — GRAY5人整列（Carpe Diemロゴ壁）
  "/images/A1_5357.jpg",
  // [14] _A1_5337 — L/S BLACK立ちポーズ（ベストショット）
  "/images/A1_5337.jpg",
  // [15] _A1_5341 — L/S GRAY アクションショット
  "/images/A1_5341.jpg",
  // [16] _A1_5399 — H/S BLACK 正面アップ
  "/images/A1_5399.jpg",
  // [17] _A1_5381 — H/S GRAY / 複数人アクションショット
  "/images/A1_5381.jpg",
  // [18] _A1_5613 — TEE ヒーローショット
  "/images/A1_5613.jpg",
  // [19] _A1_5498 — ブランド紹介セクション背景
  "/images/A1_5498.jpg",
  // [20] _A1_5449 — Fight Shorts BLACK
  "/images/A1_5449.jpg",
  // [21] _A1_5422 — Fight Shorts GRAY
  "/images/A1_5422.jpg",
];
